import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "selectBox" ]

  newValueSelected(event) {
    this.element.requestSubmit()
  }
}

